// src/components/AnimatedCounter.js

import React, { useState, useEffect, useRef } from 'react';

const AnimatedCounter = ({ target, suffix = '+', prefix = '', duration = 2500 }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          // Po tym jak stanie się widoczny, nie musimy go już obserwować
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isVisible]); // Usunięto ref.current z dependency array, aby uniknąć re-obserwacji

  useEffect(() => {
    if (!isVisible) return;

    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(target * easeOutQuart);

      setCount(currentCount);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // Upewniamy się, że na końcu jest dokładnie wartość docelowa
        setCount(target);
      }
    };
    
    requestAnimationFrame(step);
    
  }, [isVisible, target, duration]);

  return (
    <span ref={ref} className="tabular-nums">
      {prefix}{count}{(count === target) && suffix}
    </span>
  );
};

export default AnimatedCounter;